"use strict";

module.exports = {
  'name': 'typeof',
  'category': 'Utils',
  'syntax': ['typeof(x)'],
  'description': 'Get the type of a variable.',
  'examples': ['typeof(3.5)', 'typeof(2 - 4i)', 'typeof(45 deg)', 'typeof("hello world")'],
  'seealso': ['getMatrixDataType']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/utils/typeof.js
// module id = 989
// module chunks = 0